import { useEffect } from 'react';

const useDocTitle = (title) => {
  useEffect(() => {
    document.title = `ANNEX - ${title}`;
  }, [title]);
};

export default useDocTitle;